import { render, staticRenderFns } from "./BImage.vue?vue&type=template&id=30aed79e&scoped=true"
import script from "./BImage.vue?vue&type=script&lang=js"
export * from "./BImage.vue?vue&type=script&lang=js"
import style0 from "./BImage.vue?vue&type=style&index=0&id=30aed79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aed79e",
  null
  
)

export default component.exports